// This file is auto-generated from Ruby constants.
// Do not edit manually. Use rake export_ts_constants to regenerate.

export const DEMOGRAPHIC_RECOMMENDATION = {
  young_and_healthy: {
    label: "Young and Healthy Employees",
    recommendations: ["See the doctor once or twice a year", "Do not have children", "Want basic protection against major accidents or illnesses"],
    icon: "running",
  },
  chronic_conditions: {
    label: "Chronic Conditions",
    recommendations: ["Have an ongoing condition that requires frequent treatment"],
    icon: "prescription-bottle-alt",
  },
  prescription_drugs: {
    label: "Prescription Drugs",
    recommendations: ["Need prescription drugs on an ongoing basis"],
    icon: "clipboard-prescription",
  },
  families: {
    label: "Employees with Families",
    recommendations: ["Have families that see the doctor several times a year", "Need prescription drugs occasionally"],
    icon: "users",
  },
  surgeries: {
    label: "Expect Surgeries or Pregnancies",
    recommendations: ["Plan to have children within the next year", "Plan to have major surgery within the next year", "See specialists frequently"],
    icon: "baby-carriage",
  },
  travel: {
    label: "Employees In Many States",
    recommendations: ["Spread out across the state or country.", "Frequently travel the country.", "Visit doctors in multiple states."],
    icon: "plane",
  },
  suites: {
    label: "Diverse Medical Needs",
    recommendations: [
      "Wide variety of employee medical needs (single, families, older, chronic conditions).",
      "Need access to many doctors.",
      "Prefer an easy to administer plan.",
    ],
    icon: "user-md",
  },
};

export const BRAND_NAME_LOOKUP = {
  "+A Division of Health Care Service Corporation, a Mutual Legal Reserve Company, an Independent Licensee of the Blue Cross and Blue Shield Association":
    "Blue Cross Blue Shield",
  "AARP-branded plans, insured by Aetna": "AARP by Aetna",
  "Aetna Life Insurance Company": "Aetna",
  "AmeriHealth - New Jersey": "Amerihealth",
  "Assurant Health": "Assurant Health",
  "Blue Cross and Blue Shield of Illinois": "Blue Cross Blue Shield",
  "Blue Shield of California": "Blue Shield",
  "CareFirst BlueChoice, Inc. is an independent licensee of the Blue Cross and Blue Shield Association. Registered trademark of the Blue Cross and Blue Shield Association. Registered trademark of CareFirst of Maryland, Inc.":
    "CareFirst BlueChoice",
  "CareFirst BlueCross BlueShield is the shared business name of CareFirst of Maryland, Inc. and Group Hospitalization and Medical Services, Inc. which are independent licensees of the Blue Cross and Blue Shield Association. Registered trademark of the Blue":
    "CareFirst BlueCross BlueShield",
  "Celtic Ins. Co.": "Celtic",
  "Celtic Insurance Company": "Celtic",
  "CeltiCare Healthplan of MA, Inc.": "CeltiCare",
  "CIGNA HealthCare of Florida Inc": "Cigna",
  "Coventry Health and Life Insurance Co. Fl": "Coventry Health",
  "Coventry Health Care of Illinois, Inc.": "Coventry Health",
  "Coventry Health Plan of Florida, Inc.": "Coventry Health",
  "Easy Choice Health Plan of New York": "Easy Choice NY",
  "Empire HealthChoice Assurance Inc": "Empire HealthChoice",
  "Empire HealthChoice HMO Inc": "Empire HealthChoice",
  "Fallon Community Health Plan": "Fallon",
  "Group Health Options, Inc.": "Group Health Options",
  "Horizon Blue Cross Blue Shield of New Jersey": "Horizon BCBS",
  "Humana Insurance Company": "Humana",
  "Kaiser Mid-Atlantic": "Kaiser Permanente",
  "Kaiser Permanente of CA": "Kaiser Permanente",
  "LifeWise Health Plan of Washington": "LifeWise",
  "MVP Health Care": "MVP Health Care",
  "Oxford NJ": "Oxford",
  "Oxford NY": "Oxford",
  "Regence BlueShield is an independent licensee of the Blue Cross and Blue Shield Association.": "Blue Cross Blue Shield",
  "Scott & White Health Plan": "Scott & White",
};

export const PLAN_BRANDS = {
  Aetna: "aetna",
  AFLAC: "aflac",
  Allied: "allied",
  Allstate: "allstate",
  "AllWays Health Partners": "allways_health",
  altusdental: "altusdental",
  AlwaysCare: "alwayscare",
  Ambetter: "ambetter",
  AmeriHealth: "amerihealth",
  "Anthem Blue Cross": "anthem",
  "Asuris Northwest Health": "asuris",
  AvMed: "avmed",
  "AWB HealthChoice": "awb_healthchoice",
  BCBS: "bcbs",
  "Blue Cross Blue Shield SC": "bcbs_sc",
  "Blue Cross Blue Shield AZ": "bcbsaz",
  "Blue Cross Blue Shield IL": "bcbsil",
  "Blue Cross Blue Shield MA": "bcbsma",
  "Blue Cross Blue Shield MI": "bcbsmi",
  "Blue Cross Blue Shield of Minnesota": "bcbsmn",
  "Blue Cross Blue Shield of Montana": "bcbsmt",
  "Blue Cross Blue Shield NE": "bcbsne",
  "Blue Cross Blue Shield of New Mexico": "bcbsnm",
  "Blue Cross Blue Shield OK": "bcbsok",
  "Blue Cross Blue Shield RI": "bcbsri",
  "BlueCross BlueShield of Tennessee": "bcbstn",
  "Blue Cross Blue Shield of TX": "bcbstx",
  "Blue Cross Blue Shield of Vermont": "bcbsvt",
  "BlueCross BlueShield of Western New York": "bcbswny",
  BlueChoice: "blue_choice",
  "Blue Cross of Idaho": "blue_cross_idaho",
  "Blue Shield": "blue_shield",
  "Florida Blue": "blue_shield",
  "Bright HealthCare": "bright_healthcare",
  "BlueShield of Northeastern New York": "bsnny",
  "Cal Choice": "cal_choice",
  "Capital BlueCross": "capital_bluecross",
  CareConnect: "careconnect",
  "CareFirst BCBS": "carefirst_bcbs",
  CDPHP: "cdphp",
  "Choice Builder": "choice_builder",
  "Christus Health Plan": "christus_health",
  Cigna: "cigna",
  "Cigna + Oscar": "cigna_oscar",
  "Colonial Life": "colonial_life",
  "Community Health Choice": "community_health_choice",
  Connecticare: "connecticare",
  "Coventry Health Care": "coventry",
  Coventry: "coventry",
  "Crystal Run": "crystal_run",
  "Delta Dental": "delta_dental",
  "Dental Care Plus": "dental_care_plus",
  "Dental Select": "dental_select",
  EmblemHealth: "emblem_health",
  "Emblem Millennium": "emblem_health",
  "Emblem Prime": "emblem_health",
  "Emblem Select Care": "emblem_health",
  "Empire BCBS": "empire_bcbs",
  "Empire Blue Access": "empire_bcbs",
  "Empire Pathway": "empire_bcbs",
  "Empire Connection": "empire_bcbs",
  "Empire Blue Priority": "empire_bcbs",
  "Empire EPO/PPO (BlueCard)": "empire_bcbs",
  "Empire EPO/PPO": "empire_bcbs",
  "Empire PPO/EPO": "empire_bcbs",
  Equitable: "equitable",
  "Excellus BCBS": "excellus_bcbs",
  Eyemed: "eyemed",
  "Fallon Health": "fallon",
  Fallon: "fallon",
  "Fidelis Cares": "fideliscare",
  "FirstCare Health Plans": "first_care_health",
  "Florida Health Care Plans": "florida_health_care_plans",
  "Friday Health Plans": "friday_health_plans",
  "Geisinger Health Plan": "geisinger_health_plan",
  "Group Health Cooperative": "group_health",
  "Group Health Options": "group_health",
  Guardian: "guardian",
  "Harvard Pilgrim Health Care": "harvard_pilgrim",
  "Harvard Pilgrim": "harvard_pilgrim",
  HealthFirst: "health_first",
  "Health First Commercial": "health_first_commercial",
  "Health Net": "health_net",
  "Health New England": "health_new_england",
  "Health Partners": "health_partners",
  "Health Republic": "health_republic",
  "Healthy CT": "healthy_ct",
  Highmark: "highmark",
  "Highmark BLUE Shield": "highmark_blue_shield",
  "Highmark Delaware": "highmark_de",
  "Highmark Western": "highmark_western",
  "Horizon BCBS": "horizon_bcbs",
  Humana: "humana",
  "Independence Blue Cross": "independence_bc",
  "Independent Health": "independent_health",
  "Kaiser Permanente": "kaiser",
  "Kaiser NW": "kaiser_nw",
  "Kaiser WA": "kaiser_wa",
  "Lincoln Financial": "lincoln_financial",
  "Medical Mutual": "medical_mutual",
  "Medical Mutual of OH": "medical_mutual",
  MediExcel: "medi_excel",
  "Memorial Hermann Health Solutions": "memorial_hermann",
  MetLife: "metlife",
  Metlife: "metlife",
  MetroPlusHealth: "metroplushealth",
  "Minuteman Health": "minuteman",
  Oscar: "oscar",
  "Oscar Health Plan of California": "oscar",
  "Oscar Health Plan of CA": "oscar",
  "Oscar + Humana": "oscar_humana",
  Oxford: "oxford",
  "Oxford Freedom": "oxford",
  "Oxford Health Plan": "oxford",
  "Oxford Liberty": "oxford",
  "Oxford Metro": "oxford",
  PacificSource: "pacific_source",
  "Premera Blue Cross": "premera_blue_cross",
  "Priority Health": "priority_health",
  Principal: "principal",
  Providence: "providence",
  "Regence Blue Shield": "regence",
  Sana: "sana",
  "Sana Benefits": "sana",
  SBMA: "sbma",
  "Scott and White Health Plan": "scott_and_white",
  "See Change": "see_change",
  SelectHealth: "select_health",
  "Sendero Health Plans": "sendero_health_plans",
  "Sentara Health Plans": "sentara_health_plans",
  Sharp: "sharp",
  "Superior Dental": "superior_dental",
  "Sun Life": "sun_life",
  Trustmark: "trustmark",
  "The Hartford": "the_hartford",
  "Tufts Health Plan": "tufts",
  "United Concordia": "united_concordia",
  UnitedHealthcare: "united_healthcare",
  "United Healthcare": "united_healthcare",
  "United HealthCare": "united_healthcare",
  Unum: "unum",
  UPMC: "upmc",
  Vault: "vault",
  VSP: "vsp",
  "Wellmark Blue Cross Blue Shield": "wellmark_bcbs",
};

export const CARRIERS_BY_SYMBOL = {
  aetna: ["Aetna"],
  aflac: ["AFLAC"],
  allied: ["Allied"],
  allstate: ["Allstate"],
  allways_health: ["AllWays Health Partners"],
  altusdental: ["altusdental"],
  alwayscare: ["AlwaysCare"],
  ambetter: ["Ambetter"],
  amerihealth: ["AmeriHealth"],
  anthem: ["Anthem Blue Cross"],
  asuris: ["Asuris Northwest Health"],
  avmed: ["AvMed"],
  awb_healthchoice: ["AWB HealthChoice"],
  bcbs: ["BCBS"],
  bcbs_sc: ["Blue Cross Blue Shield SC"],
  bcbsaz: ["Blue Cross Blue Shield AZ"],
  bcbsil: ["Blue Cross Blue Shield IL"],
  bcbsma: ["Blue Cross Blue Shield MA"],
  bcbsmi: ["Blue Cross Blue Shield MI"],
  bcbsmn: ["Blue Cross Blue Shield of Minnesota"],
  bcbsmt: ["Blue Cross Blue Shield of Montana"],
  bcbsne: ["Blue Cross Blue Shield NE"],
  bcbsnm: ["Blue Cross Blue Shield of New Mexico"],
  bcbsok: ["Blue Cross Blue Shield OK"],
  bcbsri: ["Blue Cross Blue Shield RI"],
  bcbstn: ["BlueCross BlueShield of Tennessee"],
  bcbstx: ["Blue Cross Blue Shield of TX"],
  bcbsvt: ["Blue Cross Blue Shield of Vermont"],
  bcbswny: ["BlueCross BlueShield of Western New York"],
  blue_choice: ["BlueChoice"],
  blue_cross_idaho: ["Blue Cross of Idaho"],
  blue_shield: ["Blue Shield", "Florida Blue"],
  bright_healthcare: ["Bright HealthCare"],
  bsnny: ["BlueShield of Northeastern New York"],
  cal_choice: ["Cal Choice"],
  capital_bluecross: ["Capital BlueCross"],
  careconnect: ["CareConnect"],
  carefirst_bcbs: ["CareFirst BCBS"],
  cdphp: ["CDPHP"],
  choice_builder: ["Choice Builder"],
  christus_health: ["Christus Health Plan"],
  cigna: ["Cigna"],
  cigna_oscar: ["Cigna + Oscar"],
  colonial_life: ["Colonial Life"],
  community_health_choice: ["Community Health Choice"],
  connecticare: ["Connecticare"],
  coventry: ["Coventry Health Care", "Coventry"],
  crystal_run: ["Crystal Run"],
  delta_dental: ["Delta Dental"],
  dental_care_plus: ["Dental Care Plus"],
  dental_select: ["Dental Select"],
  emblem_health: ["EmblemHealth", "Emblem Millennium", "Emblem Prime", "Emblem Select Care"],
  empire_bcbs: [
    "Empire BCBS",
    "Empire Blue Access",
    "Empire Pathway",
    "Empire Connection",
    "Empire Blue Priority",
    "Empire EPO/PPO (BlueCard)",
    "Empire EPO/PPO",
    "Empire PPO/EPO",
  ],
  equitable: ["Equitable"],
  excellus_bcbs: ["Excellus BCBS"],
  eyemed: ["Eyemed"],
  fallon: ["Fallon Health", "Fallon"],
  fideliscare: ["Fidelis Cares"],
  first_care_health: ["FirstCare Health Plans"],
  florida_health_care_plans: ["Florida Health Care Plans"],
  friday_health_plans: ["Friday Health Plans"],
  geisinger_health_plan: ["Geisinger Health Plan"],
  group_health: ["Group Health Cooperative", "Group Health Options"],
  guardian: ["Guardian"],
  harvard_pilgrim: ["Harvard Pilgrim Health Care", "Harvard Pilgrim"],
  health_first: ["HealthFirst"],
  health_first_commercial: ["Health First Commercial"],
  health_net: ["Health Net"],
  health_new_england: ["Health New England"],
  health_partners: ["Health Partners"],
  health_republic: ["Health Republic"],
  healthy_ct: ["Healthy CT"],
  highmark: ["Highmark"],
  highmark_blue_shield: ["Highmark BLUE Shield"],
  highmark_de: ["Highmark Delaware"],
  highmark_western: ["Highmark Western"],
  horizon_bcbs: ["Horizon BCBS"],
  humana: ["Humana"],
  independence_bc: ["Independence Blue Cross"],
  independent_health: ["Independent Health"],
  kaiser: ["Kaiser Permanente"],
  kaiser_nw: ["Kaiser NW"],
  kaiser_wa: ["Kaiser WA"],
  lincoln_financial: ["Lincoln Financial"],
  medical_mutual: ["Medical Mutual", "Medical Mutual of OH"],
  medi_excel: ["MediExcel"],
  memorial_hermann: ["Memorial Hermann Health Solutions"],
  metlife: ["MetLife", "Metlife"],
  metroplushealth: ["MetroPlusHealth"],
  minuteman: ["Minuteman Health"],
  oscar: ["Oscar", "Oscar Health Plan of California", "Oscar Health Plan of CA"],
  oscar_humana: ["Oscar + Humana"],
  oxford: ["Oxford", "Oxford Freedom", "Oxford Health Plan", "Oxford Liberty", "Oxford Metro"],
  pacific_source: ["PacificSource"],
  premera_blue_cross: ["Premera Blue Cross"],
  priority_health: ["Priority Health"],
  principal: ["Principal"],
  providence: ["Providence"],
  regence: ["Regence Blue Shield"],
  sana: ["Sana", "Sana Benefits"],
  sbma: ["SBMA"],
  scott_and_white: ["Scott and White Health Plan"],
  see_change: ["See Change"],
  select_health: ["SelectHealth"],
  sendero_health_plans: ["Sendero Health Plans"],
  sentara_health_plans: ["Sentara Health Plans"],
  sharp: ["Sharp"],
  superior_dental: ["Superior Dental"],
  sun_life: ["Sun Life"],
  trustmark: ["Trustmark"],
  the_hartford: ["The Hartford"],
  tufts: ["Tufts Health Plan"],
  united_concordia: ["United Concordia"],
  united_healthcare: ["UnitedHealthcare", "United Healthcare", "United HealthCare"],
  unum: ["Unum"],
  upmc: ["UPMC"],
  vault: ["Vault"],
  vsp: ["VSP"],
  wellmark_bcbs: ["Wellmark Blue Cross Blue Shield"],
};

export const UNIQUE_PLAN_BRAND_NAMES = {
  Aetna: "aetna",
  AFLAC: "aflac",
  Allied: "allied",
  Allstate: "allstate",
  "AllWays Health Partners": "allways_health",
  altusdental: "altusdental",
  AlwaysCare: "alwayscare",
  Ambetter: "ambetter",
  AmeriHealth: "amerihealth",
  "Anthem Blue Cross": "anthem",
  "Asuris Northwest Health": "asuris",
  AvMed: "avmed",
  "AWB HealthChoice": "awb_healthchoice",
  BCBS: "bcbs",
  "Blue Cross Blue Shield SC": "bcbs_sc",
  "Blue Cross Blue Shield AZ": "bcbsaz",
  "Blue Cross Blue Shield IL": "bcbsil",
  "Blue Cross Blue Shield MA": "bcbsma",
  "Blue Cross Blue Shield MI": "bcbsmi",
  "Blue Cross Blue Shield of Minnesota": "bcbsmn",
  "Blue Cross Blue Shield of Montana": "bcbsmt",
  "Blue Cross Blue Shield NE": "bcbsne",
  "Blue Cross Blue Shield of New Mexico": "bcbsnm",
  "Blue Cross Blue Shield OK": "bcbsok",
  "Blue Cross Blue Shield RI": "bcbsri",
  "BlueCross BlueShield of Tennessee": "bcbstn",
  "Blue Cross Blue Shield of TX": "bcbstx",
  "Blue Cross Blue Shield of Vermont": "bcbsvt",
  "BlueCross BlueShield of Western New York": "bcbswny",
  BlueChoice: "blue_choice",
  "Blue Cross of Idaho": "blue_cross_idaho",
  "Blue Shield": "blue_shield",
  "Bright HealthCare": "bright_healthcare",
  "BlueShield of Northeastern New York": "bsnny",
  "Cal Choice": "cal_choice",
  "Capital BlueCross": "capital_bluecross",
  CareConnect: "careconnect",
  "CareFirst BCBS": "carefirst_bcbs",
  CDPHP: "cdphp",
  "Choice Builder": "choice_builder",
  "Christus Health Plan": "christus_health",
  Cigna: "cigna",
  "Cigna + Oscar": "cigna_oscar",
  "Colonial Life": "colonial_life",
  "Community Health Choice": "community_health_choice",
  Connecticare: "connecticare",
  "Coventry Health Care": "coventry",
  "Crystal Run": "crystal_run",
  "Delta Dental": "delta_dental",
  "Dental Care Plus": "dental_care_plus",
  "Dental Select": "dental_select",
  EmblemHealth: "emblem_health",
  "Empire BCBS": "empire_bcbs",
  Equitable: "equitable",
  "Excellus BCBS": "excellus_bcbs",
  Eyemed: "eyemed",
  "Fallon Health": "fallon",
  "Fidelis Cares": "fideliscare",
  "FirstCare Health Plans": "first_care_health",
  "Florida Health Care Plans": "florida_health_care_plans",
  "Friday Health Plans": "friday_health_plans",
  "Geisinger Health Plan": "geisinger_health_plan",
  "Group Health Cooperative": "group_health",
  Guardian: "guardian",
  "Harvard Pilgrim Health Care": "harvard_pilgrim",
  HealthFirst: "health_first",
  "Health First Commercial": "health_first_commercial",
  "Health Net": "health_net",
  "Health New England": "health_new_england",
  "Health Partners": "health_partners",
  "Health Republic": "health_republic",
  "Healthy CT": "healthy_ct",
  Highmark: "highmark",
  "Highmark BLUE Shield": "highmark_blue_shield",
  "Highmark Delaware": "highmark_de",
  "Highmark Western": "highmark_western",
  "Horizon BCBS": "horizon_bcbs",
  Humana: "humana",
  "Independence Blue Cross": "independence_bc",
  "Independent Health": "independent_health",
  "Kaiser Permanente": "kaiser",
  "Kaiser NW": "kaiser_nw",
  "Kaiser WA": "kaiser_wa",
  "Lincoln Financial": "lincoln_financial",
  "Medical Mutual": "medical_mutual",
  MediExcel: "medi_excel",
  "Memorial Hermann Health Solutions": "memorial_hermann",
  MetLife: "metlife",
  MetroPlusHealth: "metroplushealth",
  "Minuteman Health": "minuteman",
  Oscar: "oscar",
  "Oscar + Humana": "oscar_humana",
  Oxford: "oxford",
  PacificSource: "pacific_source",
  "Premera Blue Cross": "premera_blue_cross",
  "Priority Health": "priority_health",
  Principal: "principal",
  Providence: "providence",
  "Regence Blue Shield": "regence",
  Sana: "sana",
  SBMA: "sbma",
  "Scott and White Health Plan": "scott_and_white",
  "See Change": "see_change",
  SelectHealth: "select_health",
  "Sendero Health Plans": "sendero_health_plans",
  "Sentara Health Plans": "sentara_health_plans",
  Sharp: "sharp",
  "Superior Dental": "superior_dental",
  "Sun Life": "sun_life",
  Trustmark: "trustmark",
  "The Hartford": "the_hartford",
  "Tufts Health Plan": "tufts",
  "United Concordia": "united_concordia",
  UnitedHealthcare: "united_healthcare",
  Unum: "unum",
  UPMC: "upmc",
  Vault: "vault",
  VSP: "vsp",
  "Wellmark Blue Cross Blue Shield": "wellmark_bcbs",
};

export const AUTOPAY_CHECK_LOGIC = {
  premera_blue_cross: {
    payee_company_name: "Premera Blue Cross",
    payee_recipient_name: "Premera Blue Cross",
    payee_address: "Attn: Payment Processing",
    payee_address2: "PO Box 91060",
    payee_city: "Seattle",
    payee_state: "WA",
    payee_zip_code: "98111",
  },
};

export const INSURANCE_CHECK_LOGIC = {
  WA: {
    premera_blue_cross: {
      first_month_check_requirement: "signed",
      address: {
        name: "Premera Blue Cross",
        memo: "1st month insurance premium",
        street_address: "7001 220th St SW Building 1",
        city: "Mountlake Terrace",
        state: "WA",
        zip_code_number: "98043-2124",
      },
    },
  },
  TX: {
    bcbstx: {
      first_month_check_requirement: "signed",
      address: {
        name: "Blue Cross Blue Shield of TX",
        memo: "ATTN: Cheryl Parker/BenefitMall, 1st Mth",
        street_address: "4851 LBJ Freeway, Suite 100",
        city: "Dallas",
        state: "TX",
        zip_code_number: "75244",
      },
    },
    dental_select: {
      first_month_check_requirement: "signed",
      address: {
        name: "Dental Select",
        memo: "ATTN Cheryl Parker/BenefitMall, 1st Mth",
        street_address: "4851 LBJ Freeway, Suite 100",
        city: "Dallas",
        state: "TX",
        zip_code_number: "75244",
      },
    },
  },
  NJ: {
    horizon_bcbs: {
      first_month_check_requirement: "signed",
      address: {
        name: "Horizon BCBS of NJ",
        memo: "ATTN Team Hund/Savoy, 1st mth premium",
        street_address: "25B Hanover Road, Suite 220",
        city: "Florham Park",
        state: "NJ",
        zip_code_number: "07932",
      },
    },
    oxford: {
      first_month_check_requirement: "signed",
      address: {
        name: "United Healthcare Oxford",
        memo: "ATTN: Ji Lee, SimplyInsured",
        street_address: "98 Battery St #220",
        city: "San Francisco",
        state: "CA",
        zip_code_number: "94111",
      },
    },
  },
  IL: {
    bcbsil: {
      first_month_check_requirement: "signed",
      address: {
        name: "Blue Cross Blue Shield IL",
        memo: "ATTN Susan Hernandez/Resource Brokerage",
        street_address: "1501 East Woodfield Road Suite 110E",
        city: "Schaumburg",
        state: "IL",
        zip_code_number: "60173",
      },
    },
  },
  NY: {
    oxford: {
      first_month_check_requirement: "signed",
      address: {
        name: "United Healthcare Oxford",
        memo: "ATTN: Ji Lee, SimplyInsured",
        street_address: "98 Battery St #220",
        city: "San Francisco",
        state: "CA",
        zip_code_number: "94111",
      },
    },
    careconnect: {
      first_month_check_requirement: "signed",
      address: {
        name: "CareConnect",
        memo: "ATTN Tiffany Williamson,Group Enrollment",
        street_address: "2200 Northern Boulevard Suite 104",
        city: "East Hills",
        state: "NY",
        zip_code_number: "11548",
      },
    },
  },
  MO: {
    anthem: {
      first_month_check_requirement: "signed",
      address: {
        name: "Anthem Blue Cross and Blue Shield",
        memo: "ATTN Leslie Barnes, 1st month premium",
        street_address: "1831 Chestnut St.",
        city: "St. Louis",
        state: "MO",
        zip_code_number: "63103",
      },
    },
  },
  CA: {
    sharp: {
      first_month_check_requirement: "signed",
      address: {
        name: "Sharp",
        memo: "ATTN Ley Petere, SG Underwriting",
        street_address: "8520 Tech Way Suite 200",
        city: "San Diego",
        state: "CA",
        zip_code_number: "92123",
      },
    },
  },
  VA: {
    anthem: {
      first_month_check_requirement: "signed",
      address: {
        name: "Anthem Blue Cross and Blue Shield",
        memo: "ATTN: K Willey & K David, 1st mo premium",
        street_address: "4433 Corporation Lane, 1st Floor",
        city: "Virginia Beach",
        state: "VA",
        zip_code_number: "23462",
      },
    },
  },
  WI: {
    anthem: {
      first_month_check_requirement: "signed",
      address: {
        name: "Anthem Blue Cross and Blue Shield",
        memo: "ATTN: Underwriting, 1st month premium",
        street_address: "N17 W24340 Riverwood Drive",
        city: "Pewaukee",
        state: "WI",
        zip_code_number: "53188",
      },
    },
  },
  MD: {
    kaiser: {
      first_month_check_requirement: "signed",
      address: {
        name: "Kaiser Maryland",
        memo: "ATTN Benefitmall, New Biz, 1st month",
        street_address: "501 Fairmount Avenue, Suite 400",
        city: "Towson",
        state: "VA",
        zip_code_number: "21286",
      },
    },
  },
  GA: {
    kaiser: {
      first_month_check_requirement: "signed",
      address: {
        name: "BCBS GA",
        memo: "Mail Code GAG004-0004, ATTN Jena Quinn",
        street_address: "3350 Peachtree Rd NE",
        city: "Atlanta",
        state: "GA",
        zip_code_number: "30326",
      },
    },
  },
};
